import { AssetReference } from '@opallabs/cassini'
import { kuiperClassNames } from '@opallabs/kuiper'
import { ModularCarousel } from '@opallabs/periodic/src/ModularCarousel'
import { doNothing } from '../../helpers/functions/doNothing'
import { useValidModules } from '../../helpers/hooks'
import {
  Module,
  OnDragDropProps,
  OnShowAssetPickerProps,
} from '../../helpers/types'
import { StoryMobileSingle } from '../sharedDisplays/StoryMobileSingle'
import { styles } from './styles'

export type Props = {
  accountImage: AssetReference | null
  accountName: string
  allowReplies: string | null
  allowSharing: boolean
  collabAccount: string
  display: string
  instagramCollab: boolean
  isExpanded: boolean
  isPresenting: boolean
  modules: Module[]
  onAddSection?: () => void
  onDeleteSection?: (index: number) => void
  onDragDrop?: OnDragDropProps
  onExpandAsset?: () => void
  onRemoveAsset?: () => void
  postType: string
  updateSectionPostOption?: (index: number, value: string, name: string) => void
  onShowAssetPicker?: (args: OnShowAssetPickerProps) => void
  readOnly: boolean
}

export const InstagramStory: React.FC<Props> = ({
  accountImage,
  accountName,
  allowReplies,
  allowSharing,
  collabAccount,
  display,
  instagramCollab,
  isExpanded = false,
  isPresenting = false,
  modules = [],
  onAddSection,
  onDeleteSection,
  onDragDrop,
  onExpandAsset,
  onRemoveAsset,
  postType,
  updateSectionPostOption,
  onShowAssetPicker,
  readOnly = false,
}) => {
  const validModules = useValidModules({
    modules,
    onAddSection: onAddSection ? onAddSection : doNothing,
    componentNames: ['ig_story_section'],
  })

  const availableModules = [
    {
      component: StoryMobileSingle,
      componentName: 'ig_story_section',
      title: '',
    },
  ]

  return (
    <div
      css={styles.getBaseStyles(isExpanded)}
      className={kuiperClassNames(
        `instagram instagram-story instagram-story-${display}`
      )}
    >
      <ModularCarousel
        addComponentText="Add Story Section"
        allProps={{
          accountImage,
          accountName,
          allowReplies,
          allowSharing,
          collabAccount,
          instagramCollab,
          postType,
        }}
        isExpanded={isExpanded}
        availableModules={availableModules}
        carouselWidth={375}
        maxSections={1000}
        modules={validModules}
        onDragDrop={onDragDrop ? onDragDrop : doNothing}
        onAddSection={onAddSection ? onAddSection : doNothing}
        onDeleteSection={onDeleteSection ? onDeleteSection : doNothing}
        onExpandAsset={onExpandAsset ? onExpandAsset : doNothing}
        onRemoveAsset={onRemoveAsset ? onRemoveAsset : doNothing}
        onShowAssetPicker={onShowAssetPicker ? onShowAssetPicker : doNothing}
        updateSectionPostOption={
          updateSectionPostOption ? updateSectionPostOption : doNothing
        }
        readOnly={readOnly}
        isPresenting={isPresenting}
      />
    </div>
  )
}
